import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/es/guia-completa-para-validacion-de-sistemas-informaticos")({
  head: () => buildRouteHead("/es/guia-completa-para-validacion-de-sistemas-informaticos", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ to: "/es/guia-completa-validacion-sistemas-informatizados", replace: true });
  },
});
